export default "__VITE_ASSET__Aak_nCna__"